import UiSelectOption from "./UiSelectOption";

/**
 * 航程单位
 * @description 自动生成的代码,请勿修改
 */
export enum EnumVoyageUnit {
    /**
     * Day
     */
    Day = 24,
    /**
     * Hour
     */
    Hour = 1,
}

/**
 * 航程单位-选项
 */
export const EnumVoyageUnitOption: UiSelectOption<number>[] = [
    { Label: "Day", Value: 24, Data: "Day" },
    { Label: "Hour", Value: 1, Data: "Hour" },
];
